import Vue from 'vue';

const hookVueInstanceToDomElement = {
  install: (Vue: any, _options: any) => {
    Vue.mixin({
      mounted() {
        this.$el.__vueComponent__ = this;
      }
    });
  }
};

Vue.use(hookVueInstanceToDomElement);
